import React, { Component } from 'react';
import { FormGroup, Label, Form} from 'reactstrap';
import { ToastContainer, toast } from 'react-toastify';

export class AdminLogin extends Component {
  displayName = AdminLogin.name;

  constructor(props) {
	super(props);

	this.state = {
		login: '',
		password: ''
	};

	this.login = this.login.bind(this);
  }

  login(e) {
	e.preventDefault();

	var data = new FormData();

	data.append('login', this.state.login);
	data.append('password', this.state.password);


	const requestOptions = {
		method: 'POST',
		credentials: 'same-origin',
		body: data
	};

	fetch('api/DataforDB/TestForAdmin', requestOptions)
		.then(response => {
			if (!response.ok) {
				throw Error(response.statusText);
			  }
			  return response.json();
		})
		.then(data => {
			if (data) {
				localStorage.setItem('validation', data);
				window.location.href = '/'
			} else {
				toast.error('Произошла ошибка. Логин или пароль не верный.')
			}
		})
		.catch(error => toast.error('Произошла ошибка при попытке войти в систему.'));
  }

  render() {
	  return (
		  <React.Fragment>
			<ToastContainer/>
			<Form className='flex container' onSubmit={this.login}>
			<div className='login-form'>
				<h4>Вход</h4>
				<FormGroup>
					<Label>
						Логин:
						<input
							name= 'login'
							className= 'form-control'
							type='text'
							value={this.state.login}
							onChange={e => {
								var value = e.target.value;
								this.setState({login: value})
							}}
						/>
					</Label>
				</FormGroup>
				<FormGroup>
					<Label>
						Пароль:
						<input
							name= 'pass'
							className= 'form-control'
							type='password'
							value={this.state.password}
							onChange={e => {
									var value = e.target.value;
									this.setState({password: value})
								}
							}
						/>
					</Label>
				</FormGroup>
				<button className='btn btn-primary' type='submit'>Войти</button>
			</div>
		</Form>
	  </React.Fragment>
	);
  }
}
